import { isLiveMallClub } from '@/constants/systemType'

export const getOgImage = () => {
  let result = '/images/ogimage-main.png'

  if (isLiveMallClub) {
    result = '/images/livemallclub/ogimage-default.png'
  }

  return result
}
